import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { firstValueFrom } from "rxjs";

import { LoginSucceeded } from "../../store/actions/user.actions";
import { AppState } from "../../store/reducers";
import { LOGOUT_MARKER_KEY } from "./auth-storage";

@Injectable({ providedIn: "root" })
export class AuthBootstrapService {
	constructor(
		private oidcSecurityService: OidcSecurityService,
		private store: Store<AppState>
	) {}

	async init(): Promise<void> {
		if (window.location.pathname.includes("auth-callback")) {
			return;
		}

		// A deliberate logout wipes sessionStorage and drops LOGOUT_MARKER_KEY
		// immediately before navigating to Cognito. sessionStorage survives that
		// round trip, so a silent renew whose response lands after the wipe can
		// still write a fresh, valid token blob back — and checkAuth() would then
		// restore the session the user just ended. Re-wipe here, before
		// checkAuth() reads anything. (The clear removes the marker too, so this
		// applies once.) checkAuth() still runs: it is what loads the well-known
		// endpoints the subsequent login redirect needs.
		if (sessionStorage.getItem(LOGOUT_MARKER_KEY)) {
			sessionStorage.clear();
		}

		const result = await firstValueFrom(this.oidcSecurityService.checkAuth());
		if (result.isAuthenticated) {
			sessionStorage.setItem("sessionRestored", "true");
			this.store.dispatch(LoginSucceeded({ result }));
		}
	}
}
